import { render, staticRenderFns } from "./McrFormB.vue?vue&type=template&id=a8327736"
import script from "./McrFormB.vue?vue&type=script&lang=js"
export * from "./McrFormB.vue?vue&type=script&lang=js"
import style0 from "./McrFormB.vue?vue&type=style&index=0&id=a8327736&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports